<template>
  <div class="tb-board">
    <div
      v-for="number in cells"
      :key="number"
      class="tb-board__cell"
      :class="{ 'is-called': calledSet.has(number), 'is-latest': number === latest }"
    >
      {{ number }}
    </div>
  </div>
</template>

<script>
  import { BOARD_ROWS, BOARD_COLS, boardNumber } from "../constants/game";

  /** The 1-90 board, read top-to-bottom in decades. */
  export default {
    name: "NumberBoard",
    props: {
      called: {
        type: Array,
        default: () => []
      },
      // Highlighted with a ring so players can spot the newest call instantly.
      latest: {
        type: Number,
        default: null
      }
    },
    computed: {
      cells() {
        const cells = [];
        for (let row = 1; row <= BOARD_ROWS; row++) {
          for (let column = 1; column <= BOARD_COLS; column++) {
            cells.push(boardNumber(row, column));
          }
        }
        return cells;
      },
      calledSet() {
        return new Set(this.called);
      }
    }
  };
</script>
